<template>
  <div>
    <div>
      <div class="account-message">Log In with YouPaired Account</div>
      <div>
        <input placeholder="Email" type="text" v-model="email" class="email"
          name="email" @keypress.enter="loginClicked()"/>
        <input placeholder="Password" :type="passwordFieldType" v-model="password"
          name="password" @keypress.enter="loginClicked()"/>
        <font-awesome-icon class="eye" :icon="eyeIcon"
          @click="isPasswordVisible = !isPasswordVisible">
        </font-awesome-icon>
        <div class="forgot-password-container">
          <span class="forgot-password" @click="forgotPassword()">
            I forgot my password
          </span>
        </div>
      </div>
    </div>
    <div class="bottom-container" @click="loginClicked()">
      Log In >
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'login-form',
  data() {
    return {
      email: '',
      password: '',
      isPasswordVisible: false,
    };
  },
  computed: {
    passwordFieldType() {
      return this.isPasswordVisible ? 'text' : 'password';
    },
    eyeIcon() {
      return this.isPasswordVisible ? 'eye-slash' : 'eye';
    },
  },
  methods: {
    ...mapMutations('auth', ['setAuthDialogVisibility']),
    async loginClicked() {
      this.$ga.event('auth', 'local', 'login', 1);
      await this.$store.dispatch('auth/login', {
        email: this.email,
        password: this.password,
      });
    },
    forgotPassword() {
      this.$router.push('/password/forgot');
      this.setAuthDialogVisibility(false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

input {
  padding: 0.75rem;
  width: 90%;
  max-width: 20rem;
  border-radius: 0.2rem;
  border: 0.05rem solid #DCDBDB;
  -webkit-transition: border-color 0.15s;
  transition: border-color 0.15s;
  font-weight: normal;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0.5rem 0;
  font-size: 0.875rem;
}

.bottom-container {
  height: 3rem;
  line-height: 3rem;
  width: 100%;
  bottom: 0;
  color: white;
  background-color: $bottom-container;
  font-size: 1.3rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid $bottom-container;
}

.error-text {
  color: red;
}

.forgot-password-container {
  padding: 1rem 0;
}

.forgot-password {
  cursor: pointer;
  color: blue;
}

.eye {
  cursor: pointer;
  position: relative;
  right: 1.5rem;
  margin-right: -1rem;
}
.account-message {
  font-size:1rem;
  margin: 1rem 0;
}

</style>
